import * as React from 'react'
import {
  WrappedFieldProps,
  Field,
  GenericField,
  BaseFieldProps
} from 'redux-form'
import UserSelect from '../UserSelect'
import ControlWrapper from './ControlWrapper'
import { styles } from './SelectControl'

export interface UserSelectControlCustomProps {
  multi?: boolean
}

export type UserSelectControlProps = WrappedFieldProps &
  UserSelectControlCustomProps

const UserSelectControl: React.SFC<UserSelectControlProps> = props => {
  const { input, label, meta, multi } = props

  return (
    <ControlWrapper name={input.name} label={label} meta={meta}>
      <UserSelect
        onBlur={() => (input.onBlur as any)()}
        onFocus={() => (input.onFocus as any)()}
        value={input.value}
        onChange={input.onChange}
        multi={multi}
        name={input.name}
        styles={styles(meta.touched && meta.error)}
      />
    </ControlWrapper>
  )
}

const CustomField = Field as new () => GenericField<
  UserSelectControlCustomProps
>

export type UserSelectControlFieldProps = BaseFieldProps<
  UserSelectControlCustomProps
> &
  UserSelectControlCustomProps

export const UserSelectControlField: React.SFC<
  UserSelectControlFieldProps
> = props => <CustomField {...props} component={UserSelectControl} />

export default UserSelectControl



// WEBPACK FOOTER //
// ./src/components/form/UserSelectControl.tsx